import { NeedsActivityDto } from '@act/shared/data-transfer-objects';
import { Box, Typography } from '@mui/material';

interface ActivityLearnMoreContentProps {
  activity: NeedsActivityDto;
}

const ActivityLearnMoreContent = ({
  activity,
}: ActivityLearnMoreContentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        paddingTop: '12px',
      }}
    >
      <Box>
        <Typography variant="subheadLarge">Overview</Typography>
      </Box>
      <Box>
        <Typography variant="bodyLarge">
          {activity?.overview
            ? activity?.overview
            : `There doesn't seem to be any content associated with this activity.`}
        </Typography>
      </Box>
    </Box>
  );
};

export default ActivityLearnMoreContent;
